"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDrillForKpiWidgetHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var kpi_1 = require("../../events/kpi");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var widgetValidations_1 = require("./validation/widgetValidations");
var layout_1 = require("../../store/layout");
function removeDrillForKpiWidgetHandler(ctx, cmd) {
    var correlationId, widgets, kpiWidget, widgetRef;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                correlationId = cmd.correlationId;
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetsMap)];
            case 1:
                widgets = _a.sent();
                kpiWidget = widgetValidations_1.validateExistingKpiWidget(widgets, cmd, ctx);
                widgetRef = kpiWidget.ref;
                return [4 /*yield*/, effects_1.put(layout_1.layoutActions.replaceKpiWidgetDrill({
                        ref: widgetRef,
                        drill: undefined,
                        undo: {
                            cmd: cmd,
                        },
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/, kpi_1.kpiWidgetDrillRemoved(ctx, widgetRef, correlationId)];
        }
    });
}
exports.removeDrillForKpiWidgetHandler = removeDrillForKpiWidgetHandler;
//# sourceMappingURL=removeDrillForKpiWidgetHandler.js.map